/* =============================================================================
 * Competicao selecionada - o contexto em que o app inteiro esta'.
 *
 * O Futigol e' usado dentro de UMA competicao por vez: quem acompanha a liga do
 * bairro nao fica pulando de campeonato a cada toque. Por isso a competicao
 * deixou de ser um parametro que toda URL interna precisa carregar e virou uma
 * escolha guardada no aparelho: `/competicoes/rodadas` em vez de
 * `/competicoes/rodadas/12`.
 *
 * O id CONTINUA sendo aceito na URL quando ele vem (`/competicoes/rodadas/12`),
 * e nesse caso ele ganha e passa a ser a selecao. E' o que mantem funcionando o
 * link de jogo compartilhado no WhatsApp - a preocupacao que ja' esta' escrita
 * no cabecalho de app/roteador.js. Quem normaliza isso e' a guarda
 * `exigirCompeticao` de app/guardas.js: quando a pagina roda, a selecao ja'
 * esta' gravada, entao a pagina so' le `idCompeticaoAtual()`.
 *
 * Fica no localStorage, ao lado dos favoritos e da categoria escolhida: e'
 * preferencia de aparelho, nao de conta - e sobrevive a fechar o navegador, que
 * e' justamente o ponto.
 * ========================================================================== */

import { persistente } from '@shared/lib/armazenamento.js';
import { paraInteiro, paraTexto } from '@shared/lib/valores.js';

const CHAVE = 'competicao';

/**
 * A competicao selecionada, ou null.
 *
 * Guardamos descricao/imagem junto do id de proposito: sao o suficiente para a
 * tela dizer em qual competicao a pessoa esta' ANTES da primeira resposta do
 * servidor chegar.
 *
 * @returns {{ id: number, descricao: string, liga: string, imagem: string }|null}
 */
export function competicaoAtual() {
    const bruto = persistente.ler(CHAVE, null);
    const id = paraInteiro(bruto?.id);
    if (id <= 0) return null;
    return { id, descricao: paraTexto(bruto.descricao), liga: paraTexto(bruto.liga), imagem: paraTexto(bruto.imagem) };
}

/** @returns {number} 0 quando nenhuma competicao foi escolhida. */
export function idCompeticaoAtual() {
    return competicaoAtual()?.id ?? 0;
}

/**
 * Grava a selecao. Aceita o id sozinho (e' o que a guarda tem em maos, vindo da
 * URL) ou a competicao ja' mapeada pela pagina.
 *
 * Passar so' o id NAO apaga o rotulo ja' guardado da mesma competicao - senao
 * reabrir a mesma tela por um link com id deixaria a selecao sem nome ate' o
 * fetch responder.
 */
export function selecionarCompeticao(competicao) {
    const id = paraInteiro(typeof competicao === 'object' && competicao !== null ? competicao.id : competicao);
    if (id <= 0) return null;

    const anterior = competicaoAtual();
    const base = anterior?.id === id ? anterior : { id, descricao: '', liga: '', imagem: '' };
    const nova = {
        id,
        descricao: paraTexto(competicao?.descricao) || base.descricao,
        liga: paraTexto(competicao?.liga) || base.liga,
        imagem: paraTexto(competicao?.imagem) || base.imagem,
    };

    persistente.gravar(CHAVE, nova);
    return nova;
}

export function limparCompeticao() {
    persistente.remover(CHAVE);
}
